/* eslint-disable */

import { actions } from 'forms/rrf';
import * as moment from 'moment';
import { toast } from 'react-toastify';
import FileDownload from 'react-file-download';
import store, { history } from '../store';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';
import { objectToFormData, removeNullFieldsFromJson } from "../utils/commonFunctions";

const prepareIncentivePayload = (payLoad) => {
  const incentiveData = removeNullFieldsFromJson(payLoad);

  if (incentiveData.groups) {
    incentiveData.group_ids = incentiveData.groups.map(curr => curr.value);

    delete incentiveData.groups;
  }

  if (incentiveData.product_ids) {
    incentiveData.product_ids = incentiveData.product_ids.map(curr => curr.value);
  }

  if (incentiveData.abm_codes) {
    incentiveData.incentives_abms_attributes = incentiveData.abm_codes.map(curr => ({ abm_code: curr.value }));
  }

  if (incentiveData.wse_bands) {
    incentiveData.incentives_wse_bands_attributes = incentiveData.wse_bands.map(curr => ({ wse_band: curr.value }));
  }

  if (incentiveData.postcodes) {
    incentiveData.incentives_postcodes_attributes = incentiveData.postcodes.map(curr => ({ postcode: curr.value }));
  }

  if (incentiveData.sub_zones) {
    incentiveData.incentives_sub_zones_attributes = incentiveData.sub_zones.map(curr => ({ horizon_sub_zone_id: curr.value }));
  }

  if (incentiveData.zones) {
    incentiveData.incentives_zones_attributes = incentiveData.zones.map(curr => ({ horizon_zone_id: curr.value }));
  }

  if (incentiveData.game_levels) {
    const gameLevelsAttributes = Object.entries(incentiveData.game_levels).map((gameLevel) => {
      const level = +gameLevel[0].split('-')[1];
      const values = gameLevel[1];

      if (values['_destroy'] && values['id']) {
        return {
          id: values['id'].value,
          _destroy: 1
        }
      }

      return {
        level,
        id: values['id'] ? +values['id'].value : null,
        minimum_number_of_scans: +values['minimum-number-of-scans'].value,
        prize_amount: +values['prize-amount'].value,
        cataboom_id: values['cataboom-id'].value
      }
    });

    incentiveData.game_levels_attributes = gameLevelsAttributes;

    delete incentiveData.game_levels;
  }

  return objectToFormData(incentiveData, 'incentive');
};

export const getIncentive = (id) => (dispatch) => {
    dispatch({type: "GET_INCENTIVE_PENDING", payload: []});
    const url = `/api/admin/incentives/${id ? id : 'new'}`;
    return irelandApi
        .get(url)
        .then((response) => {
          const parseDate = (date) => {
            if (date) {
              return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
            } else {
              return '';
            }
          };
          const createProductList = (products) => {
            return products.map((curr) => {
              return {
                label: `${curr.sku_name} ${curr.sku_code}`,
                value: curr.id
              }
            });
          };
          const createGroupList = (groups) => {
              groups.map((curr) => {
                return {
                  label: `${curr.name}`,
                  value: curr.id
                }
              });
          };
          const data = response.data.data;
          const attributes = data.attributes;
          const meta = response.data.meta;

          if (id) {
            dispatch(actions.load('deep.incentives', {
              "name": attributes['name'],
              "mc_outlets": attributes['mc-outlets'],
              "abm_codes": attributes['abm-codes'],
              "wse_bands": attributes['wse-bands'],
              "postcodes": attributes['postcodes'],
              "zones": attributes['zones'],
              "groups": attributes['groups'],
              "sub_zones": attributes['sub-zones'],
              "description": attributes['description'],
              "start_date": attributes['start-date'],
              "end_date": attributes['end-date'],
              "current_date_before_start_date": attributes['current-date-before-start-date'],
                "submission_grace_period": attributes['submission-grace-period'],
              "kind": attributes['kind'].replace(/-/g, '_'),
              "incentive_type": attributes['incentive-type'],
              "target": attributes['target'],
              "game_qualification_chance": attributes['game-qualification-chance'],
              "default_target": attributes['default-target'],
              "maximum_points": attributes['maximum-points'],
              "percentage_calculate_from": attributes['percentage-calculate-from'],
              "percentage_calculate_to": attributes['percentage-calculate-to'],
              "points_to_target": attributes['points-to-target'],
              "points_to_target_2": attributes['points-to-target-2'],
              "points_after_target": attributes['points-after-target'],
              "display_from": attributes['display-from'],
              "display_to": attributes['display-to'],
              "product_ids": createProductList(attributes['products']),
              "group_ids": createGroupList(attributes['groups']),
              "image_uid": attributes['image-uid'],
              "links": attributes['links'],
              "bonus_points_enabled": attributes['bonus-points-enabled'],
              "bonus_points_to_target": attributes['bonus-points-to-target'],
              "bonus_points_to_target_2": attributes['bonus-points-to-target-2'],
              "bonus_points_after_target": attributes['bonus-points-after-target'],
              "maximum_bonus_submissions": attributes['maximum-bonus-submissions'],
              "bonus_points_from": attributes['bonus-points-from'],
              "bonus_points_to": attributes['bonus-points-to'],
              "bonus_link": attributes['bonus-link'],
              "game_levels": attributes['game-levels']
              }));
            store.dispatch(actions.resetValidity('deep.incentives'));
          } else {
            dispatch(actions.load('deep.incentives', {
              "name": '',
              "start_date": '',
              "end_date": '',
              "kind": attributes['kind'].replace(/-/g, '_'),
              "incentive_type": attributes['incentive-type'],
              "target": '',
              "default_target": '',
              "maximum_points": '',
              "percentage_calculate_from": '',
              "percentage_calculate_to": '',
              "points_to_target": '',
              "points_after_target": '',
              "display_from": '',
              "display_to": '',
              "product_ids": '',
              "group_ids": '',
              "image_uid": '',
              "links": {"image" : ''},
              "bonus_points_enabled": 'false',
              "bonus_points_to_target": '',
              "bonus_points_to_target_2": '',
              "bonus_points_after_target": '',
              "maximum_bonus_submissions": '',
              "bonus_points_from": '',
              "bonus_points_to": '',
              "bonus_link": '',
              "game_qualification_chance": 100,
              "game_levels": {}
            }));
          }
          dispatch({
            type: "GET_INCENTIVE_FULFILLED",
            payLoad: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: 'GET_INCENTIVE_REJECTED',
            payLoad: error.response
          });

          return Promise.reject(error.response.data.errors);
        })
};

export const getIncentives = (name, dateFrom, dateTo, page = 1) => (dispatch) => {
  dispatch({ type: 'GET_INCENTIVES_PENDING', payload: [] });

  // The backend's Incentive.filter_by does JSON.parse(params[:q]), so q must reach it as a JSON
  // string. axios 1.x otherwise serialises this nested object as bracket notation
  // (q[incentive_name]=...), which Rails turns into a hash → JSON.parse throws → rescue {} → no
  // filtering. The shared irelandApi paramsSerializer (utils/legacyParamsSerializer) restores
  // axios 0.x's object→JSON serialisation centrally, so q stays a plain object here like every
  // other admin search.
  const q = {
    end_date_from: dateFrom,
    end_date_to: dateTo,
    incentive_name: name
  };

  return irelandApi.get('/api/admin/incentives', { params: { page, q } })
    .then((response) => {
      dispatch({ type: 'GET_INCENTIVES_FULFILLED', payLoad: response.data });
    })
    .catch((error) => {
      dispatch({ type: 'GET_INCENTIVES_REJECTED', payLoad: error.data });
      return Promise.reject(error.response.data);
    });
};

export const downloadIncentives = id => dispatch => irelandApi.get(`/api/admin/incentives/${id}/download`)
  .then((response) => {
    let filename = 'Incentive.csv';
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    FileDownload(response.data, filename);
  })
  .catch((error) => {
    // toast.error(<ToastMessage iconStyle="error" message={`Incentive can not be downloaded: ${error.response.data.errors[0]}`}/>);
  });

const prepareIncentiveFormData = (payLoad) => {
  let formData = new FormData();
  Object.keys(payLoad).forEach(key => {
    if (key === 'product_ids' || key === 'group_ids') {
      payLoad[key].forEach(id => formData.append(`incentive[${key}][]`, id))
    } else {
      formData.append(`incentive[${key}]`, payLoad[key])
    }
  });
  return formData;
};

const errorsFrom = error => (error.response && error.response.data && error.response.data.errors) || null;

export const clearIncentiveErrors = () => ({type: 'CLEAR_INCENTIVE_ERRORS'});

export const saveIncentive = (data, dispatch) => {
  const formData = prepareIncentivePayload(data);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  dispatch({type: "ADD_INCENTIVES_PENDING"});
  return irelandApi.post('/api/admin/incentives', formData, config)
    .then((response) => {
      dispatch({
        type: 'ADD_INCENTIVES_FULFILLED',
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Incentive created successfully"/>);
      history.push('/admin/incentives');
      dispatch(actions.reset('deep.incentives'));
    })
    .catch((error) => {
      const errors = errorsFrom(error);

      dispatch({
        type: 'ADD_INCENTIVES_REJECTED',
        payLoad: errors
      });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during create incentive"/>);

      return Promise.reject(errors);
    });
};

export const updateIncentive = (id, data, dispatch) => {
  const formData = prepareIncentivePayload(data);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  dispatch({type: "UPDATE_INCENTIVES_PENDING"});
  return irelandApi.patch(`/api/admin/incentives/${id}`, formData, config)
    .then((response) => {
      dispatch({
        type: 'UPDATE_INCENTIVES_FULFILLED',
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Incentive updated successfully"/>);
      history.push('/admin/incentives');
    })
    .catch((error) => {
      const errors = errorsFrom(error);

      dispatch({
        type: 'UPDATE_INCENTIVES_REJECTED',
        payLoad: errors
      });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during update incentive"/>);

      return Promise.reject(errors);
    });
};
